import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hall } from "../../../service";
import {
    Button,
    Empty,
    Divider,
    Space,
    Card,
    Tag,
} from 'antd';
import {
    ArrowLeftOutlined,
} from '@ant-design/icons';

export default function CpyDetails() {
    const { id } = useParams()
        , navigate = useNavigate()
        , [record, setRecord] = useState({})
        , basic = useSelector(state => state.basic)

    useEffect(() => {
        if (id) {
            async function fetchData() {
                const { data } = await hall.apiHall.getDetails(id)
                setRecord(data)
            }
            fetchData()
        }
    }, [])

    return (
        <div className='record-details-container'>
            <div className='details-header'>
                <Button
                    icon={<ArrowLeftOutlined />}
                    type='text'
                    onClick={() => navigate(-1)}
                >返回</Button>
            </div>

            {
                record ? (
                    <div className='container-display-center'>

                    </div>

                ) : (null)
            }


        </div>
    )
}
